import React from "react";
import "./Square.css";



export function Square(props) {
		return (
			<button id={props.id} className="square" onClick={() => {props.onClick()}}>
				{props.value}
			</button>
		);
}

